import { Component, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { HeaderStateService } from '../main/headers/services/header-state.service';
import { NotificationsStateService } from '../notifications/services/notifications-state.service';

@Component({
    selector: 'app-inbox',
    templateUrl: './inbox.component.html',
    styleUrl: './inbox.component.scss'
})
export class InboxComponent implements OnInit {
    constructor(
        private headerStateService: HeaderStateService,
        private translocoService: TranslocoService,
        private notificationsStateService: NotificationsStateService
    ) {
        this.headerStateService.setDetailHeader(
            this.translocoService.translate('main.header.inboxTitle'),
            this.translocoService.translate('main.header.inboxDescription'))
    }
    ngOnInit(): void {
        this.notificationsStateService.loadNotificationsAsync();
    }
}